import {Routes} from "@angular/router";
import {LocationRoutes} from "./_models/_enums/location-routes";
import {PrintersComponent} from "./printers/printers.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";
import {CashPointsComponent} from "./cash-points/cash-points.component";
import {
  CashPointsAssistantClosingComponent
} from "./cash-points-assistant-closing/cash-points-assistant-closing.component";
import {EventsComponent} from "./events/events.component";
import {EventDetailsComponent} from "./event-details/event-details.component";
import {OpenTablesComponent} from "../open-tables/overview/open-tables.component";
import {PrinterSettingsComponent} from "./printer-settings/printer-settings.component";
import {TableLayoutComponent} from "../table-layout/manager/table-layout.component";
import {Roles} from "../../_auth/x-enums/roles";

export const LOCATION_ROUTES: Routes = [
  {
    path: LocationRoutes.Printers, component: PrintersComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_PrinterComponent().default},
    title: "Drucker"
  },
  {
    path: LocationRoutes.PrinterSettings, component: PrinterSettingsComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.device_printer_get.default}
  },
  {
    path: LocationRoutes.CashPoints, component: CashPointsComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_CashPointComponent().default},
    title: "Kassen"
  },
  {
    path: LocationRoutes.CashPointsClosingAssistant,
    component: CashPointsAssistantClosingComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.Permissions_CashPointsAssistantClosingComponent().default},
    title: "Kassen-Assistent"
  },
  {
    path: LocationRoutes.Events,
    component: EventsComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.Permissions_EventsComponent().default},
    title: "Events"
  },
  {
    path: LocationRoutes.EventDetails,
    component: EventDetailsComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.Permissions_EventDetailsComponent().default},
    title: "Event-Details"
  },
  {
    path: LocationRoutes.BookingEntityOverview, component: OpenTablesComponent,
    canActivate: [AuthGuard],
    // The live open-tables overview (#205) replaces the old "Buchungen: Tische" list. Operator is a STANDALONE
    // baseline role held instead of ShardAdmin/Employee, so it has to be listed explicitly — it is not implied by
    // any of the others.
    data: {roles: [Roles.ShardAdmin, Roles.CompanyOwner, Roles.PlatformOwner, Roles.Operator]},
    title: "Offene Tische"
  },
  {
    path: LocationRoutes.TableLayout,
    component: TableLayoutComponent,
    canActivate: [AuthGuard],
    // Persistent table catalog + floor-plan areas — shard-scoped data, so it lives under Standort, not Unternehmen.
    data: {roles: [Roles.ShardAdmin, Roles.CompanyOwner, Roles.PlatformOwner]},
    title: "Tische & Bereiche"
  },
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
]
